const CONST = {
  topic: {
    play: { literal: 'event.play', label: 'Play', payloadType: null }, // payload null
    pause: { literal: 'event.pause', label: 'Pause', payloadType: null }, // payload null
    setData: { literal: 'event.set.data', label: 'Set Data' }, // payload timelineObject[]
    setTime: { literal: 'event.set.time', label: 'Set Time', payloadType: typeof(Number) }, // payload number
    setMute: { literal: 'event.set.mute', label: 'Set Mute', payloadType: typeof(Boolean) }, // payload boolean
    clearData: { literal: 'event.clear.data', label: 'Clear Data', payloadType: null }, // payload null
    clearTime: { literal: 'event.clear.time', label: 'Clear Time', payloadType: null }, // payload null
    clearMute: { literal: 'event.clear.mute', label: 'Clear Mute', payloadType: null }, // payload null
    clearAll: { literal: 'event.clear.all', label: 'Clear All', payloadType: null }, // payload null
    trigger: { literal: 'event.trigger', label: 'Trigger', payloadType: typeof(Number) }, // payload number
    increment: { literal: 'event.increment', label: 'Increment', payloadType: null }, // deprecated
    simStateChanged: { literal: 'event.sim.changed', label: 'Sim State Changed', payloadType: null },
    nodeListChanged: { literal: 'event.nodeList.changed', label: 'Node List Changed' }, // payload nodeList
  },
  nodeType: {
    parent: { literal: '__nodeType.parent' },
    child: { literal: '__nodeType.child' }
  },
  sampleDelay: {
    reference: [ 8, 9, 10, 11, 12, 14, 16, 22, 30, 40 ],
    secondsPerSample: 1 / 200,
    numberOfIntensities: 10
  },
  maxDataLength: 512,
  bufferSize: 256
}

export default CONST;